import { Col, Divider, Row } from "antd";
import { ShortCut } from "./ShortCut"
import {
    UpCircleOutlined,
    DownCircleOutlined,
    MenuUnfoldOutlined,
    PicRightOutlined,
    AlignLeftOutlined,
    AlignRightOutlined,
} from '@ant-design/icons';
import { SystemDescriptions } from "src/common/descriptions";
import { useNavigate } from "react-router";
import { Urls } from "src/common/urls";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getPayableContractsApi } from "src/features/PayableContract/state/action";
import { FuturePayments } from "src/features/Dashboard/Statistics/FuturePayments";
import { PayableContract } from "src/common/models/payableContract";
import { serviceLoading } from "src/common/apiLoader/state/selection";
import { RootState } from "src/state/reducer";
import { GET_PAYABLE_CONTRACTS_API } from "src/features/PayableContract/state/actionTypes";
import InnerLoader from "src/components/InnerLoader";
import { SystemConstants } from "src/common/constants";

interface ReduxProps {
    isGettingPayableContracts: boolean
    futurePayments?: PayableContract[]
}

export const ShortCuts = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        isGettingPayableContracts: serviceLoading(state, [GET_PAYABLE_CONTRACTS_API]),
        futurePayments: state.payableContract.payableContracts,
    }))

    useEffect(() => {
        dispatch(getPayableContractsApi({
            nextServiceDebitRange: SystemConstants.NEXT_SERVICE_DEBIT_RANGE,
        }))
    }, [])

    const descriptions = SystemDescriptions.COMPONENTS.DASHBOARD

    return (
        <Row
            gutter={[16, 16]}
            style={{
                marginBottom: 36,
            }}
        >
            <Divider orientation="left">{descriptions.SHORTCUTS.TITLE}</Divider>
            <Col xs={12} md={8}>
                <ShortCut
                    title={descriptions.SHORTCUTS.ACCOUNT_RECEIVABLES}
                    icon={DownCircleOutlined}
                    onClick={() => navigate(Urls.FRONTEND.SERVICE_CONTRACT_DEBIT.SERVICE_CONTRAC_DEBITS)}
                />
            </Col>
            <Col xs={12} md={8}>
                <ShortCut
                    title={descriptions.SHORTCUTS.ACCOUNT_PAYABLES}
                    icon={UpCircleOutlined}
                    onClick={() => navigate(Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT.PAYABLE_CONTRACT_DEBITS)}
                />
            </Col>
            <Col xs={12} md={8}>
                <ShortCut
                    title={descriptions.SHORTCUTS.CREATE_EXPENDITURE_RECORD}
                    icon={MenuUnfoldOutlined}
                    onClick={() => navigate(Urls.FRONTEND.EXPENDITURE_RECORD.CREATE)}
                />
            </Col>
            <Col xs={12} md={8}>
                <ShortCut
                    title={descriptions.SHORTCUTS.CREATE_SERVICE_CONTRACT}
                    icon={PicRightOutlined}
                    onClick={() => navigate(Urls.FRONTEND.SERVICE_CONTRACT.CREATE)}
                />
            </Col>
            <Col xs={12} md={8}>
                <ShortCut
                    title={descriptions.SHORTCUTS.PAYABLE_CONTRACTS}
                    icon={AlignLeftOutlined}
                    onClick={() => navigate(Urls.FRONTEND.ACCOUNT_PAYABLE.PAYABLE_CONTRACTS)}
                />
            </Col>
            <Col xs={12} md={8}>
                <ShortCut
                    title={descriptions.SHORTCUTS.SERVICE_CONTRACTS}
                    icon={AlignRightOutlined}
                    onClick={() => navigate(Urls.FRONTEND.SERVICE_CONTRACT.SERVICE_CONTRACTS)}
                />
            </Col>
            <Col xs={24} md={24}>
                {
                    reduxProps.isGettingPayableContracts
                        ? <InnerLoader />
                        : <FuturePayments
                            title={descriptions.FUTURE_PAYABLES.TITLE}
                            data={reduxProps.futurePayments || []}
                        />
                }
            </Col>
        </Row>
    )
}
